import { get } from "lodash"
import { call } from "redux-saga/effects"
import { ValidationError, TechnicalError, ForbiddenError, NotJsonError, UnauthorizedError, NotFoundError } from "./errors"
import { getToken } from "./token"

async function processResponse(response) {
  const contentType = response.headers.get("content-type")
  if (response.status === 404) {
    throw new NotFoundError()
  } else if (response.status === 401) {
    throw new UnauthorizedError()
  } else if (response.status === 403) {
    throw new ForbiddenError()
  } else if (contentType && contentType.indexOf("application/json") !== -1) {
    const body = await response.json()
    if (response.status === 400) {
      if (body.errors) {
        throw new ValidationError(body.errors)
      } else {
        throw new TechnicalError(body)
      }
    } else if (response.status > 400) {
      throw new TechnicalError(body.errors || body)
    } else {
      return { data: body.data, apiMessages: { errors: body.errors, messages: get(body, "extensions.messages") } }
    }
  } else {
    throw new NotJsonError(response)
  }
}

export function* sendQuery(query, variables, account, beta = false, signal) {
  const token = yield call(getToken)
  const result = yield call(fetch, `/graphql${beta ? "/beta" : ""}?account=${account}`, {
    credentials: "same-origin",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-OmegaPoint": "client",
      "X-OmegaPoint-Code": token,
    },
    body: JSON.stringify({ query, variables }),
    signal,
  })
  return yield call(processResponse, result)
}
